<template>
  <div class="caifu_ts" id="tswdcfdj">
    <topNav typeName vuePage="#tswdcfdj" title="提升我的财富等级" back="1" closeweb="1"></topNav>

    <div class="ts_top">
      <p>什么是财富等级</p>
      <p>财富等级是用户在朱贝中消费金额的对应等级。</p>
    </div>

    <div class="ts_center">
      <p class="ts_center_title">等级积分方式</p>
      <div class="ts_center_info">
        <span>加分项</span>
        <span>分值</span>
      </div>
      <ul>
        <li>
          <p>直播礼物钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>道具商城钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>守护钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>弹幕钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>私信钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
      </ul>
    </div>

    <div class="tc_bottom">说明：免费礼物不纳入财富等级计算，背包礼物是用户在朱贝消费或活动免费获赠的礼物，有过期时间，任意类型现金和礼物抽奖均不纳入财富等级计算。</div>
  </div>
</template>






<script>
import topNav from "../index/top_nav";

export default {
  components: {
    topNav
  },
  data() {
    return {
      multiple: "", //消费砖石的倍数
      // upScoreList: [
      //   { id: 1, scorename: "直播礼物钻石消费", scoreInfo: "+1*消费钻石数量" },
      //   { id: 2, scorename: "道具商城钻石消费", scoreInfo: "+1*消费钻石数量" },
      //   { id: 3, scorename: "守护钻石消费", scoreInfo: "+1*消费钻石数量" },
      //   { id: 4, scorename: "弹幕钻石消费", scoreInfo: "+1*消费钻石数量" },
      //   { id: 5, scorename: "私信钻石消费", scoreInfo: "+1*消费钻石数量" },
      // ]
    };
  },
  methods: {
    getInfo() {
      let _this = this;
      let data = {
        type: 0,
      };
      _this.$jsonp(_this.$apis("grade_wealth"), data, (res) => {
        _this.multiple = res.body.data.data.list.multiple;
      });
    },
  },
  mounted() {
    this.$tool.setTitle("提升我的财富等级");
    this.getInfo();
  },
};
</script>






<style lang="scss" scoped>
.caifu_ts {
  width: 100%;
}
.ts_top {
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  background-color: #fff;
}
.ts_top p:nth-child(1) {
  color: #414141;
  font-weight: bold;
  padding: 18px 0;
}
.ts_top p:nth-child(2) {
  color: #9b9b9b;
  font-size: 0.9rem;
  padding: 20px 0;
  padding-top: 0;
}
.ts_center {
  background-color: #fff;
  padding: 0 15px;
  .ts_center_title {
    padding: 30px 0;
    color: #414141;
    font-weight: 600;
  }
  .ts_center_info {
    color: #414141;
    font-weight: 600;
    font-size: 0.8rem;
    margin-bottom: 10px;
  }
  .ts_center_info span {
    display: inline-block;
    width: 50%;
  }
  ul li {
    color: #b0b0b0;
    display: flex;
    font-size: 0.9rem;
    padding: 18px 0;
    p {
      width: 50%;
      text-align: left;
    }
  }
}
.tc_bottom {
  padding: 15px 15px 40px;
  color: #b0b0b0;
  font-size: 0.8rem;
  line-height: 1.8;
}
</style>